import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_URL } from '../../../api/api';
import { useNavigate } from 'react-router-dom';

const ManageMemberSearchLayer = () => {
    const token = localStorage.getItem('token');
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [branches, setBranches] = useState([]);
    const [groups, setGroups] = useState([]);

    const [form, setForm] = useState({
        state: '',
        district: '',
        branch: '',
        group: '',
    });

    useEffect(() => {
        fetchStates();
    }, []);

    const fetchStates = async () => {
        try {
            const res = await axios.get(`${API_URL}/state`);
            setStates(res.data);
        } catch (error) {
            console.error("Error fetching states", error);
            Swal.fire("Error", "Failed to load states", "error");
        }
    };

    const handleSearch = () => {
        const { branch, group } = form;

        if (!branch || !group) {
            return Swal.fire("Error", "Please fill all fields before searching", "warning");
        }

        const query = new URLSearchParams({
            branch,
            group,
        }).toString();

        //const url = `/manage-member?${query}`;
        const url = `/software/manage-member?${query}`;
        window.open(url, '_blank');
    };


    const handleStateChange = (option) => {
        const selectedState = states.find(state => state.state_code === option.value);
        setForm({ ...form, state: option.value, district: '', branch: '', group: '' });
        setDistricts(selectedState?.districts ?? []);
        setBranches([]);
        setGroups([]);
    };

    const handleDistrictChange = async (option) => {
        setForm(prev => ({ ...prev, district: option.value, branch: '', group: '' }));
        try {
            const districtSlug = option.value.toLowerCase();
            const res = await axios.get(`${API_URL}/districts/${districtSlug}/branches`);
            setBranches(res.data);
            setGroups([]);
        } catch (error) {
            console.error("Error fetching branches", error);
            Swal.fire("Error", "Failed to load branches", "error");
        }
    };

    const handleBranchChange = async (option) => {
        setForm(prev => ({ ...prev, branch: option.value, group: '' }));
        setGroups([]);
        try {
            const res = await axios.get(`${API_URL}/branches/${option.value}/groups`);
            setGroups(res.data);
        } catch (error) {
            console.error("Error fetching groups", error);
            Swal.fire("Error", "Failed to load groups", "error");
        }
    };

    const handleGroupChange = (option) => {
        setForm(prev => ({ ...prev, group: option.value }));
    };

    const toSelectOptions = (arr, labelKey = 'name', valueKey = 'id') =>
        arr.map(item => ({
            value: item[valueKey],
            label: item[labelKey],
        }));

    return (
        <div className="container py-4">
            <div className="card shadow-sm">
                <div className="card-header bg-warning text-black">
                    <p className="mb-0">📋 Search Member</p>
                </div>
                <div className="card-body">
                    <div className="row g-3">

                        {/* State */}
                        <div className="col-md-6">
                            <label className="form-label">State</label>
                            <Select
                                options={toSelectOptions(states, 'state_name', 'state_code')}
                                value={toSelectOptions(states, 'state_name', 'state_code').find(opt => opt.value === form.state)}
                                onChange={handleStateChange}
                                placeholder="Select State"
                            />
                        </div>

                        {/* District */}
                        <div className="col-md-6">
                            <label className="form-label">District</label>
                            <Select
                                options={toSelectOptions(districts, 'district', 'district')}
                                value={toSelectOptions(districts, 'district', 'district').find(opt => opt.value === form.district)}
                                onChange={handleDistrictChange}
                                placeholder="Select District"
                            />
                        </div>

                        {/* Branch */}
                        <div className="col-md-6">
                            <label className="form-label">Branch</label>
                            <Select
                                options={toSelectOptions(branches, 'branchname')}
                                value={toSelectOptions(branches, 'branchname').find(opt => opt.value === form.branch)}
                                onChange={handleBranchChange}
                                placeholder="Select Branch"
                            />
                        </div>

                        {/* Group */}
                        <div className="col-md-6">
                            <label className="form-label">Group</label>
                            <Select
                                options={toSelectOptions(groups, 'groupname')}
                                value={toSelectOptions(groups, 'groupname').find(opt => opt.value === form.group)}
                                onChange={handleGroupChange}
                                placeholder="Select Group"
                                isDisabled={!form.branch || groups.length === 0}
                            />
                        </div>
                        {/* Button */}
                        <div className="col-12 text-end">
                            <button className="btn btn-primary px-4" onClick={handleSearch}>
                                🔍 Search
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageMemberSearchLayer;
